import React from "react";
import { Button } from "@/modern/components/ui/button";
import { Save, Settings } from "lucide-react";
import { NotesMenu } from "@/react/components/entityViews/notes/components/NotesMenu";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { useNotesEditorContext } from "@/react/components/entityViews/notes/context/NotesEditorContext";
import { cn } from "@/modern/utils";

export const NotesEditorHeader = ({ className }: { className?: string }) => {
  const { noteRecord, entityRecord, isNewNote, isSaveDisabled, isSettingsOpen, wordCount, onSettingsToggle, onDeleteNote, onClose } = useNotesEditorContext();
  return (
    <div className={cn("flex items-center justify-between py-3 border-b gap-2 min-w-0", className)}>
      <div className="flex items-center gap-3 flex-1 overflow-hidden">
        <h2 className="text-xl text-foreground mt-1">{noteRecord?.name?.length > 0 ? "Edit note" : "Create new note"}</h2>
      </div>
      <div className="flex items-center gap-2 flex-none">
        <p className="text-sm  text-muted-foreground mt-1 mr-2 whitespace-nowrap">
          {wordCount.words} words, {wordCount.characters} characters
        </p>
        <ButtonGroup>
          <Button type="submit" variant={isSaveDisabled ? "outline" : "default"} size="sm" disabled={isSaveDisabled} className="gap-2">
            <Save />
            {isNewNote ? "Save Note" : "Save Changes"}
          </Button>
          <Button type="button" variant={isSettingsOpen ? "default" : "outline"} size="sm" onClick={onSettingsToggle} className="gap-2">
            <Settings />
            Settings
          </Button>
          <NotesMenu
            record={entityRecord}
            noteRecord={noteRecord}
            isEditor={true}
            onDeleteNote={() => {
              onDeleteNote?.();
              onClose();
            }}
          />
        </ButtonGroup>
      </div>
    </div>
  );
};
